//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useContext, useEffect } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { Button, makeStyles, FormControlLabel, Radio, FormControl, RadioGroup } from '@material-ui/core';
import { Grid } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView } from '../../system/firebase';
import { PATH_HOME, STRIPE_FREE_TRIAL_LENGTH } from '../../system/constants';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { HOMEPAGE_CONTACT, PAGE_TITLE_EMPLOYERS, PAGE_TITLE_EMPLOYERS_SEO } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import image1 from '../../images/Employers/image (1).png';
import image2 from '../../images/Employers/Re-record video.png';
import image3 from '../../images/Employers/image (2).png';
import image4 from '../../images/Employers/image (4).jpg';
import cardImg1 from '../../images/Employers/avatar7.png';
import cardImg2 from '../../images/Employers/avatar6 (1).png';
import cardComma from '../../images/Employers/Vector.png';
import circleImg1 from '../../images/Employers/avatar1 (1).png';
import circleImg2 from '../../images/Employers/avatar2 (1).png';
import circleImg3 from '../../images/Employers/avatar3 (1).png';
import circleImg4 from '../../images/Employers/Ellipse 23.png';
import EmployersBanner from '../../images/Banner/Home_Employers.jpg';
import tickImg from '../../images/Employers/Vector112.png';
import circle from '../../images/Banner/circle.png';
import Footer from './Footer';
import tier1 from '../../images/Employers/tier-1.png';
import tiers2 from '../../images/Employers/tier-2.png';
import tiers3 from '../../images/Employers/tier-3.png';
import circleBottom from '../../images/Banner/circle-bottom.png';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../common/elemental/AfitdPageHead';
import AfitdLink from '../../common/elemental/AfitdLink';
// import CreateAccountModal from './CreateAccountModal';
import AfitdMessageDialog from '../../common/elemental/AfitdMessageDialog';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
import { MESSAGE_TITLE_ENGAGEMENT_INFO, MESSAGE_ENGAGEMENT_INFO } from '../../common/constants';
import LoginDialog from '../../topNav/subComponents/LoginDialog';
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        overflowX: 'hidden',
    },
    primaryHeading: {
        fontSize: '42px',
        fontWeight: 700,
        lineHeight: '52px',
        textAlign: 'center',
        maxWidth: 920,
        margin: 'auto',
        marginBottom: '60px',
        marginTop: 80,
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
    },
    secondaryHeading: {
        fontSize: '42px',
        fontWeight: 700,
        lineHeight: '52px',
        maxWidth: '450px',
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px', textAlign: 'center', margin: 'auto' },
    },
    secondaryHeading2: {
        fontSize: '42px',
        fontWeight: 700,
        lineHeight: '52px',
        maxWidth: '450px',
        [theme.breakpoints.up('lg')]: { marginTop: '-60px' },
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px', textAlign: 'center', margin: 'auto' },
    },
    secondaryParagraph: { fontSize: '26px', fontWeight: 700, lineHeight: '52px', maxWidth: '450px', [theme.breakpoints.down('sm')]: { textAlign: 'center', margin: 'auto' } },
    imageContainer: { textAlign: 'center' },
    paragraphContainer: { maxWidth: '450px', [theme.breakpoints.down('sm')]: { margin: 'auto' } },
    paragraph: { fontSize: '20px', fontWeight: 400, lineHeight: '34px', [theme.breakpoints.down('sm')]: { fontSize: 18, lineHeight: '26px', textAlign: 'center', margin: 'auto' } },
    employerSection: { display: 'flex', flexDirection: 'column', justifyContent: 'center' },
    employerSection2: { display: 'flex', flexDirection: 'column', justifyContent: 'center', [theme.breakpoints.up('md')]: { paddingLeft: 75 } },
    employerSection3: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingLeft: 20,
        // marginTop: '-200px',
        [theme.breakpoints.up('lg')]: { paddingLeft: 75 }, //marginTop: '-230px'
    },
    employerContainer: { marginBottom: 100 },
    textCenter: { textAlign: 'center', marginBottom: '100px', fontSize: '16px' },
    pricingOptionsHeader2: { textAlign: 'center', marginBottom: '100px', fontSize: 26 },
    freeTrialText: { fontWeight: 'bold', color: theme.palette.secondary.main },
    cardContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        marginBottom: '100px',
        // maxWidth: '1000px',
        margin: 'auto',
        [theme.breakpoints.down('md')]: { flexDirection: 'column', width: 'auto' },
        // [theme.breakpoints.up('lg')]: { maxWidth: '1108px' },
        // [theme.breakpoints.down('lg')]: { maxWidth: '1000px' },
    },
    card: {
        width: '43%',
        height: '310px',
        backgroundColor: '#FDF1CB',
        borderRadius: '8px',
        padding: '30px',
        [theme.breakpoints.down('lg')]: { height: 390 },
        [theme.breakpoints.down('md')]: { width: 'auto', marginBottom: '16px', height: 290 },
        [theme.breakpoints.down('sm')]: { height: 410 },
        // [theme.breakpoints.up('lg')]: { width: 385 },
        // [theme.breakpoints.up('xl')]: { width: 480 },
    },
    cardTop: { display: 'flex', justifyContent: 'space-between' },
    cardName: { display: 'flex', justifyContent: 'space-around' },
    cardTextPrimary: { fontSize: '20px', margin: 0, padding: 0, paddingLeft: '16px' },
    cardTextSecondary: { fontSize: '15px', margin: 0, padding: 0, paddingLeft: '16px' },
    lastContainer: { textAlign: 'center', margin: '100px 0' },
    contactUsLink: { color: '#1d8a8b', fontWeight: 'bold', textDecoration: 'underline', marginRight: 6 },
    sellingContainer: { margin: '90px 0' },
    sellingSection: { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' },
    sellingBox: {
        width: 210,
        backgroundColor: '#F0F2F6',
        borderRadius: '16px',
        marginBottom: '16px',
        padding: '17px',
        [theme.breakpoints.only('lg')]: { width: 190 },
        [theme.breakpoints.only('md')]: { width: 130 },
        [theme.breakpoints.down('sm')]: { width: 320, textAlign: 'center' },
    },
    sellingBoxText: { margin: '0px', fontSize: '20px' },
    sellingBoxSecondary: {
        width: 210,
        backgroundColor: 'white',
        border: '1px solid #D5D7DD',
        borderRadius: '16px',
        marginBottom: '16px',
        padding: '17px',
        [theme.breakpoints.only('lg')]: { width: 190 },
        [theme.breakpoints.only('md')]: { width: 130 },
        [theme.breakpoints.down('sm')]: { width: 320, textAlign: 'center' },
    },
    bannerContainer: {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),url('${EmployersBanner}')`,
        height: '710px',
        // position: 'relative',
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        [theme.breakpoints.down('lg')]: { justifyContent: 'center' },
        [theme.breakpoints.down('md')]: { height: 490 },
        [theme.breakpoints.down('sm')]: { height: 600, textAlign: 'center' },
    },
    bannerContent1: {
        position: 'relative',
        paddingLeft: 90,
        paddingTop: 120,
        [theme.breakpoints.down('lg')]: { paddingLeft: 0, paddingTop: 100, paddingRight: 145 },
        [theme.breakpoints.down('md')]: { paddingTop: 60, paddingRight: 0 },
        [theme.breakpoints.down('sm')]: { paddingTop: 20 },
    },
    bannerContent2: { textAlign: 'right' },
    bannerImageBottomContainer: { position: 'absolute', bottom: -4, right: 0 },
    bannerHeading: { fontSize: 54, color: 'white', [theme.breakpoints.down('md')]: { fontSize: 42 }, [theme.breakpoints.down('sm')]: { fontSize: 24, paddingTop: '30px' } },
    bannerParagraph: { fontSize: 18, color: 'rgba(255, 255, 255, 0.8)', [theme.breakpoints.down('sm')]: { fontSize: 18, padding: '14px' } },
    bannerButton: { padding: '12px 44px', fontSize: 20, [theme.breakpoints.down('sm')]: { fontSize: 15, padding: '10px 18px' } },
    circleImage: { paddingTop: 334 },
    buttonContainer: { paddingTop: 60, [theme.breakpoints.down('sm')]: { paddingTop: 50 } },
    pricingContainer: { marginBottom: '100px' },
    // pricingSection: { display: 'flex', justifyContent: 'center', alignItems: 'center' },
    pricingCard: {
        // width: '100%',
        height: '700px',
        border: '2px solid #fafafa', //'none',
        boxShadow: '0px 14.96px 20px rgba(0, 0, 0, 0.07)',
        borderRadius: '8px',
        padding: '32px',
        '&:hover': {
            border: '2px solid #FC821F',
        },
        [theme.breakpoints.up('lg')]: { padding: '35px' },
    },
    cardStatus: { margin: 0, fontSize: '24px', fontWeight: 700 },
    cardParagraph: { fontWeight: 400, fontSize: '16px', lineHeight: '24px', marginBottom: '8px' },
    dropParagraph: { fontWeight: 400, fontSize: '15px', lineHeight: '24px', marginBottom: '8px' },
    cardMoneyMonth: { fontWeight: 700, fontSize: '36px', lineHeight: '40px' },
    cardMoneyMonthFree: { fontWeight: 700, fontSize: '36px', lineHeight: '40px', color: theme.palette.secondary.main },
    cardMoneyYear: { fontWeight: 700, fontSize: '20px', lineHeight: '20px' },
    dropName: { fontWeight: 500, fontSize: '20px', lineHeight: '20px' },
    cardTrialButton: {
        padding: '12px 76px',
        [theme.breakpoints.only('lg')]: { padding: '12px 41px' },
        fontSize: '16px',
        lineHeight: '40px',
        borderRadius: '4px',
        border: 'none',
        backgroundColor: '#F0F2F6',
        margin: '25px 0',
        '&:hover': {
            backgroundColor: '#FC821F',
            color: '#FFFFFF',
            cursor: 'pointer',
        },
    },

    cardBold: { fontWeight: 700 },
    li: { listStyleImage: 'url(' + tickImg + ')', marginBottom: '6px', paddingLeft: '15px' },
    cardSave: { fontSize: '11px', lineHeight: '16px', color: '#1D8A8B', padding: '4px 8px', backgroundColor: 'rgba(29,138,139, 0.2)', borderRadius: '34px', marginLeft: '8px' },
    cardPopular: { fontSize: '11px', lineHeight: '16px', color: '#FC821F', padding: '4px 8px', backgroundColor: 'rgba(252,130,31, 0.2)', borderRadius: '34px' },
    dropUp: {
        borderRadius: '8px',
        width: '302px',
        padding: '0 24px',
        marginBottom: '7px',
        display: 'flex',
        border: '1px solid #fafafa',
        '&:hover': { border: '1px solid #D5D7DD' },
        [theme.breakpoints.down('sm')]: { margin: 'auto', width: '100%' },
    },
    dropDown: {
        backgroundColor: '#D6F3F3',
        borderRadius: '8px',
        width: '302px',
        marginBottom: '7px',
        padding: '24px',
        [theme.breakpoints.up('md')]: { width: 255 },
        // [theme.breakpoints.only('md')]: { width: 185 },
        [theme.breakpoints.up('lg')]: { width: 302 },
        // [theme.breakpoints.only('lg')]: { width: 256 },
        [theme.breakpoints.up('xl')]: { width: 'auto' },
        [theme.breakpoints.down('sm')]: { margin: 'auto', width: '100%' },
    },
    section2: { display: 'flex', flexDirection: 'column', paddingLeft: '10px', [theme.breakpoints.down('sm')]: { paddingLeft: 0, margin: 'auto' } },
    circleImageContainer: { display: 'flex', marginTop: '70px', [theme.breakpoints.down('sm')]: { marginLeft: 'auto', marginRight: 'auto' } },
    circleImgContainer: { textAlign: 'center', marginRight: '16px' },
    circleImg: { [theme.breakpoints.down('sm')]: { width: 60 } },
    dropRadio: { display: 'flex' },
    leadInTextContainer: { display: 'flex', justifyContent: 'center' },
    leadInTextContent: { padding: '50px 0px 30px 0px', textAlign: 'center' },
    leadInTextHeading: { fontSize: 41, fontWeight: 'bold', [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px', textAlign: 'center' } },
    leadInTextPara: { fontSize: 20, fontWeight: '400', paddingTop: '18px' },
    cardLastText: { fontSize: '13px', marginLeft: '53px' }, //marginTop: '40px'
    cardStar: { color: '#fc821f' },
    mainContainer: {
        paddingLeft: '60px',
        paddingRight: '60px',
        [theme.breakpoints.down('sm')]: { paddingLeft: '10px', paddingRight: '10px' },
        [theme.breakpoints.up('md')]: { paddingLeft: '25px', paddingRight: '25px' },
        [theme.breakpoints.up('lg')]: { padding: '0 120px' },
        [theme.breakpoints.only('lg')]: { padding: '0 44px' },
    },
    img: { width: '100%' },
    cardList: {
        marginLeft: '-15px',
    },
    engageText: { color: 'blue', textDecoration: 'underline', cursor: 'pointer' },
    font26: { fontSize: 26 },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, loginModalOpen, setLoginModalOpen, handleOpenLoginModal, engageModal, setEngageModal, handleCloseLoginModal } = params;

    const defns = {
        employerContainer: { container: true, justify: 'center' },
        employerSection: { item: true, lg: 6, md: 6, sm: 12, xs: 12 },
        mainContainer: { container: true, xl: 10, lg: 11, md: 10, sm: 11, xs: 11 },
        employerSection2: { item: true, lg: 6, md: 6, sm: 12, xs: 12 },
        employerSection3: { item: true, lg: 6, md: 6, sm: 12, xs: 12 },
        sellingContainer: { container: true, spacing: 0 },
        sellingSection: { item: true, lg: 3, md: 3, sm: 12, xs: 12 },
        bannerContainer: { container: true, direction: 'row' },
        bannerContent1: { item: true, xl: 8, lg: 11, md: 11, sm: 12, xs: 12 },
        bannerContent2: { item: true, xl: 4, lg: 4, md: 4, sm: 4, xs: 4 },
        pricingContainer: { container: true, spacing: 2, justifyContent: 'space-evenly' },
        pricingSection: { item: true, lg: 4, md: 6, sm: 12, xs: 12 },
        section1: { item: true, lg: 8, md: 7, sm: 12, xs: 12 },
        section2: { item: true, lg: 4, md: 5, sm: 12, xs: 12 },
        createAccount: { loginModalOpen, setLoginModalOpen },
        bannerButton: { onClick: handleOpenLoginModal },
        cardTrialButton: { onClick: handleOpenLoginModal },
        engageText: { onClick: () => setEngageModal(true) },
        engagementInfoModal: {
            title: MESSAGE_TITLE_ENGAGEMENT_INFO,
            open: engageModal,
            message: MESSAGE_ENGAGEMENT_INFO,
            onClose: () => setEngageModal(false),
        },
        loginDialog: {
            open: loginModalOpen,
            isLoginMode: false,
            noLogin: true,
            onClose: handleCloseLoginModal,
            hideJS: true,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Employers = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const theme = useTheme();
    const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
    const matchesXl = useMediaQuery(theme.breakpoints.up('xl'));
    const matchesMdUp = useMediaQuery(theme.breakpoints.up('md'));

    const [loginModalOpen, setLoginModalOpen] = useState(false);
    const [engageModal, setEngageModal] = useState(false);

    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    const layoutContext = useContext(LayoutContext);
    const { scrollToPageTop } = layoutContext;
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;
    let history = useHistory();
    const handleContactUsLinkClick = () => {
        history.push(`${PATH_HOME}/${HOMEPAGE_CONTACT}`);
    };
    const handleOpenLoginModal = () => {
        setLoginModalOpen(true);
    };

    const handleCloseLoginModal = () => {
        setLoginModalOpen(false);
    };
    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(PAGE_TITLE_EMPLOYERS);
    }, []);

    // on mount, scroll to the top of the page
    useEffect(() => {
        scrollToPageTop();
    }, [scrollToPageTop]);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, loginModalOpen, setLoginModalOpen, handleOpenLoginModal, engageModal, setEngageModal, handleCloseLoginModal });

    // radio group MIU
    const [value, setValue] = useState('active');

    const handleChange = event => {
        setValue(event.target.value);
    };

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <AfitdPageHead
                title={PAGE_TITLE_EMPLOYERS_SEO}
                description="Our unique platform harnesses the power of storytelling through 60-second personality-driven videos to help businesses discover passionate and talented workers with potential."
                keywords="hire talented employees, 60-Second Interview Pitch, Interview Pitch"
                // canonicalUrl={`https://${AFITD_DOMAIN}${PATH_HOME}/${HOMEPAGE_EMPLOYERS}`}
            />
            {/* banner section start */}
            <Grid {...defns.bannerContainer}>
                <Grid {...defns.bannerContent1}>
                    <h1 {...defns.bannerHeading}>Attract Top Talent {'&'} Take Your Brand Further Than Ever Before</h1>

                    <p {...defns.bannerParagraph}>
                        We make it easy for you to find the best and brightest entry to mid-level candidates the world has to offer.
                        {matchesXl ? <br /> : ' '}
                        <span style={{ fontWeight: 'bold' }}>A Foot in the Door</span> helps you harness the power of storytelling through 60 second personality-driven videos to
                        meet passionate human beings bursting with potential.
                    </p>

                    <div {...defns.buttonContainer}>
                        <Button variant="contained" color="primary" value="CREATE A BUTTON HERE" {...defns.bannerButton}>
                            CREATE A COMPANY PROFILE
                        </Button>
                    </div>
                    {matchesXl
                        ? null
                        : matchesMdUp && (
                              <Grid {...defns.bannerImageBottomContainer}>
                                  <img {...defns.circleImageBottom} src={circleBottom} alt="" />
                              </Grid>
                          )}
                </Grid>
                {matchesXl ? (
                    <Grid {...defns.bannerContent2}>
                        <img {...defns.circleImage} src={circle} alt="" />
                    </Grid>
                ) : null}
            </Grid>
            {/* banner section end */}

            {/* tiers section */}
            <div {...defns.mainContainer}>
                <div {...defns.leadInTextContainer}>
                    <div {...defns.leadInTextContent}>
                        <h1 {...defns.leadInTextHeading}>Brand pages put your company’s culture on the center stage</h1>
                        <p {...defns.leadInTextPara}>
                            One thing about applicants, they are in a hurry to find the right fit and launch their future. <br />
                            With a <span style={{ fontWeight: 'bold' }}>full-featured company Brand Page</span>, you’re helping candidates choose you for all the right reasons.
                            <br />
                            Not only that, you get to showcase the innovative brand you worked so hard to grow.
                        </p>
                    </div>
                </div>
                <Grid {...defns.employerContainer}>
                    <Grid {...defns.section1}>
                        <div {...defns.imageContainer}>
                            {value === 'active' && <img {...defns.img} src={tier1} alt="" />}
                            {value === 'emerging' && <img {...defns.img} src={tiers2} alt="" />}
                            {value === 'global' && <img {...defns.img} src={tiers3} alt="" />}
                        </div>
                    </Grid>
                    <Grid {...defns.section2}>
                        <FormControl component="fieldset">
                            <RadioGroup aria-label="report" name="report" value={value} onChange={handleChange}>
                                <div {...defns.radioContainer}>
                                    {/* 1st tier */}
                                    <div>
                                        {value === 'active' ? (
                                            <div {...defns.dropDown}>
                                                <div {...defns.dropRadio}>
                                                    <FormControlLabel value="active" control={<Radio />} label="Active (Tier 1)" />
                                                </div>

                                                <p {...defns.dropParagraph}>
                                                    <span {...defns.cardBold}>Features</span>
                                                </p>
                                                <ul {...defns.cardList}>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span style={{ fontWeight: 'bold' }}>Unlimited</span> Candidate Resume Views
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        Post <strong> 3 </strong> ‘Active’ Jobs Simultaneously
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.engageText}>Engage</span> with <strong>60</strong> unique candidates per billing period (
                                                        <strong>720</strong> for yearly plans)
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.cardBold}>1</span> user seat (account login)
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.cardBold}>Basic</span> company Brand Page
                                                    </li>
                                                    {/* <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.cardBold}>Global Badge</span>
                                                    </li> */}
                                                </ul>
                                            </div>
                                        ) : (
                                            <div {...defns.dropUp} style={{ marginTop: '23px' }}>
                                                <FormControlLabel value="active" control={<Radio />} label="Active (Tier 1)" />
                                            </div>
                                        )}
                                    </div>
                                    {/* 2nd tier */}
                                    <div>
                                        {value === 'emerging' ? (
                                            <div {...defns.dropDown}>
                                                <div {...defns.dropRadio}>
                                                    <FormControlLabel value="emerging" control={<Radio />} label="Emerging Growth (Tier 2)" />
                                                </div>
                                                <p {...defns.dropParagraph}>
                                                    <span {...defns.cardBold}>Features</span>
                                                </p>
                                                <ul {...defns.cardList}>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.cardBold}>Unlimited</span> Candidate Resume Views
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        Post <strong>7</strong> ‘Active’ Jobs Simultaneously
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.engageText}>Engage</span> with <strong>420</strong> unique candidates per billing period (
                                                        <strong>5,040</strong> for yearly plans)
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        Internal chat with your team. Never miss a beat!
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <strong>3</strong> user seats (account logins)
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <strong>Full</strong> company Brand Page
                                                    </li>
                                                </ul>
                                            </div>
                                        ) : (
                                            <div {...defns.dropUp}>
                                                <FormControlLabel value="emerging" control={<Radio />} label="Emerging Growth (Tier 2)" />
                                            </div>
                                        )}
                                    </div>

                                    {/* 3rd tier */}
                                    <div>
                                        {value === 'global' ? (
                                            <div {...defns.dropDown}>
                                                <div {...defns.dropRadio}>
                                                    <FormControlLabel value="global" control={<Radio />} label="Global (Tier 3)" />
                                                </div>
                                                <p {...defns.dropParagraph}>
                                                    <span {...defns.cardBold}>Features</span>
                                                </p>
                                                <ul {...defns.cardList}>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.cardBold}>Unlimited </span>
                                                        Candidate Resume Views
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        Post <span {...defns.cardBold}>Unlimited </span>
                                                        Jobs Simultaneously
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <strong>Unlimited</strong> candidate <span {...defns.engageText}>engagements</span> for each billing period
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.cardBold}>10</span> user seats (account logins)<span {...defns.cardStar}>*</span>
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        Internal chat with your team. Never miss a beat!
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <span {...defns.cardBold}>Full </span>
                                                        Company Branding with consolidated job listings page
                                                    </li>
                                                    <li {...defns.dropParagraph} {...defns.li}>
                                                        <strong>Verified ‘Global’ Account Badge – </strong> <br /> Exclusive benefit to Tier 3 Plans
                                                    </li>
                                                </ul>
                                                <p {...defns.cardLastText}>
                                                    <span {...defns.cardStar}>*</span>Additional seats can be purchased <br /> at $99 per month / per seat.
                                                </p>
                                            </div>
                                        ) : (
                                            <div {...defns.dropUp}>
                                                <FormControlLabel value="global" control={<Radio />} label="Global (Tier 3)" />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </RadioGroup>
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid {...defns.employerContainer}>
                    <Grid {...defns.employerSection}>
                        <h2 {...defns.secondaryHeading2}>Publish your job listings in record time</h2>
                        <div {...defns.paragraphContainer}>
                            <p {...defns.paragraph}>
                                Make your job requirements searchable to job seekers much faster via our easy to use forms. Share your company’s needs and job specifics more
                                accurately so you can find the right fit for your business.
                            </p>
                        </div>
                        <div {...defns.circleImageContainer}>
                            <div {...defns.circleImgContainer}>
                                <img {...defns.circleImg} src={circleImg1} alt="" />
                            </div>
                            <div {...defns.circleImgContainer}>
                                <img {...defns.circleImg} src={circleImg3} alt="" />
                            </div>
                            <div {...defns.circleImgContainer}>
                                <img {...defns.circleImg} src={circleImg2} alt="" />
                            </div>
                            <div {...defns.circleImgContainer}>
                                <img {...defns.circleImg} src={circleImg4} alt="" />
                            </div>
                        </div>
                    </Grid>
                    <Grid {...defns.employerSection}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={image1} alt="" />
                        </div>
                    </Grid>
                </Grid>
                <Grid {...defns.employerContainer}>
                    <Grid {...defns.employerSection} {...defns.imageContainer}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={image2} alt="" />
                        </div>
                    </Grid>
                    <Grid {...defns.employerSection2}>
                        <h2 {...defns.secondaryHeading}>Know The Human Behind The Resume.</h2>
                        <div {...defns.paragraphContainer}>
                            <p {...defns.paragraph}>
                                “I can’t wait to review this pile of resumes,” said absolutely nobody! No more tedious and exhaustive candidate sourcing. Talent sourcing can take
                                up to 45% of the job hiring process! Watch 60 second profile videos from a diverse pool of individuals pitching their unique story and skills in
                                living color. Now you can find a great fit for your company’s culture and knock out everything else on your to-do list with all of the new-found
                                extra time you have.
                            </p>
                        </div>
                    </Grid>
                </Grid>
                <h1 {...defns.primaryHeading}>Diversity is a gift!</h1>
                <p {...defns.paragraph} {...defns.textCenter} style={{ fontSize: '20px' }}>
                    At the end of the day, your new hire needs to fit in with your mission so you <br /> don’t end up back at square one.{' '}
                    <span style={{ fontWeight: 'bold' }}>
                        Bright minds come from different <br />
                        backgrounds.
                    </span>{' '}
                    Diverse minds bring diverse solutions.
                </p>

                <div {...defns.imageContainer} style={{ marginBottom: 40 }}>
                    <img style={{ maxWidth: 917 }} {...defns.img} src={image4} alt="" />
                </div>

                {matchesSm ? (
                    <Grid {...defns.employerContainer}>
                        <h1 {...defns.primaryHeading}>Modern Minds, Modern World, Modern Methods, For Finding The Right Fit.</h1>
                        <Grid {...defns.employerSection}>
                            <h2 {...defns.secondaryParagraph}>Employers, the way we see it...</h2>
                            <div {...defns.paragraphContainer}>
                                <p {...defns.paragraph}>
                                    Statistics only get you so far when needing to hire a great fit the first go-round. That’s why we believe in
                                    <span style={{ fontWeight: 'bold' }}> Stories Over Stats.</span> When you get to know the human being behind the title, GPA and certification,
                                    you realize exactly how well an applicant will fit within the role, fit within your company culture, and your future. Genuinely speaking, the
                                    world is filled with fresh talent that just needs an <span style={{ fontWeight: 'bold' }}> opportunity</span> to prove their value and grow. You
                                    will gain insights that can never be gained from reviewing a paper resume.
                                    <br /> <br />
                                    <span style={{ fontWeight: 'bold' }}>You will never look at candidate sourcing the same after using our platform!</span>
                                </p>
                            </div>
                        </Grid>
                        <Grid {...defns.employerSection} {...defns.imageContainer}>
                            <div {...defns.imageContainer} style={{ marginTop: 30 }}>
                                <img {...defns.img} src={image3} alt="" />
                            </div>
                        </Grid>
                    </Grid>
                ) : (
                    <Grid {...defns.employerContainer}>
                        <h1 {...defns.primaryHeading}>Modern Minds, Modern World, Modern Methods, For Finding The Right Fit.</h1>
                        <Grid {...defns.employerSection} {...defns.imageContainer}>
                            <div {...defns.imageContainer}>
                                <img {...defns.img} src={image3} alt="" />
                            </div>
                        </Grid>
                        <Grid {...defns.employerSection3}>
                            <h2 {...defns.secondaryParagraph}>Employers, the way we see it...</h2>
                            <div {...defns.paragraphContainer}>
                                <p {...defns.paragraph}>
                                    Statistics only get you so far when needing to hire a great fit the first go-round. That’s why we believe in
                                    <span style={{ fontWeight: 'bold' }}> Stories Over Stats.</span> When you get to know the human being behind the title, GPA and certification,
                                    you realize exactly how well an applicant will fit within the role, fit within your company culture, and your future. Genuinely speaking, the
                                    world is filled with fresh talent that just needs an <span style={{ fontWeight: 'bold' }}> opportunity</span> to prove their value and grow. You
                                    will gain insights that can never be gained from reviewing a paper resume.
                                    <br /> <br />
                                    <span style={{ fontWeight: 'bold' }}>You will never look at candidate sourcing the same after using our platform!</span>
                                </p>
                            </div>
                        </Grid>
                    </Grid>
                )}
                <div {...defns.cardContainer}>
                    <div {...defns.card}>
                        <div {...defns.cardTop}>
                            <div {...defns.cardName}>
                                <div {...defns.cardImg}>
                                    <img src={cardImg1} alt="" />
                                </div>
                                <div {...defns.cardText}>
                                    <p {...defns.cardTextPrimary}>Syeed Ahmed</p>
                                    <p {...defns.cardTextSecondary}>Recruiter</p>
                                </div>
                            </div>
                            <div {...defns.cardComma}>
                                <img src={cardComma} alt="" />
                            </div>
                        </div>
                        <p {...defns.cardParagraph}>
                            "A Foot in the Door is my new go-to recruitment tool. The ability to schedule an interview right from a candidate’s profile combined with the ability to
                            conduct virtual interviews within the platform has been a game-changer! This product has literally given me back hours of time every single week. It may
                            sound funny, but it makes my job as a recruiter fun again. Each video is like a new adventure.”
                        </p>
                    </div>
                    <div {...defns.card}>
                        <div {...defns.cardTop}>
                            <div {...defns.cardName}>
                                <div {...defns.cardImg}>
                                    <img src={cardImg2} alt="" />
                                </div>
                                <div {...defns.cardText}>
                                    <p {...defns.cardTextPrimary}>Janice Lee</p>
                                    <p {...defns.cardTextSecondary}>Hiring Manager</p>
                                </div>
                            </div>
                            <div {...defns.cardComma}>
                                <img src={cardComma} alt="" />
                            </div>
                        </div>
                        <p {...defns.cardParagraph}>
                            "My favorite feature about this platform is the 60-second candidate videos. Scouring through resume after resume can become tedious, but I’ve found that
                            the videos and the modern approach to potential employee profiles actually make it enjoyable in addition to informative. A Foot in the Door is leading
                            the evolution of employment platforms."
                        </p>
                    </div>
                </div>

                <h1 {...defns.primaryHeading}>Pricing Options Fit For Any Size Company</h1>
                <p {...defns.paragraph} {...defns.pricingOptionsHeader2}>
                    No risk <span {...defns.freeTrialText}>{STRIPE_FREE_TRIAL_LENGTH}-Day Free Trial.</span> Cancel anytime, but we're confident that you'll love it here...
                </p>
                <Grid {...defns.pricingContainer}>
                    <Grid {...defns.pricingSection}>
                        <div {...defns.pricingCard}>
                            <p {...defns.cardStatus}>Active</p>
                            <p {...defns.cardParagraph}>Tier 1</p>
                            {/* <p {...defns.cardParagraph}>
                                <span {...defns.cardMoneyMonth}>${numberWithCommas('499')}</span>
                                <span style={{ fontWeight: 'bold' }}> / USD</span> month
                            </p> */}
                            {/* <p {...defns.cardparagraph}>
                                <span {...defns.cardMoneyYear}>${numberWithCommas('5389')}</span>
                                <span style={{ fontWeight: 'bold' }}> / USD</span> year <span {...defns.cardSave}>Save $599</span>
                            </p> */}
                            <p {...defns.cardparagraph}>
                                <span {...defns.cardMoneyMonthFree}>Free</span>
                            </p>
                            <p {...defns.cardparagraph}>
                                <span {...defns.cardMoneyYear} style={{ visibility: 'hidden' }}>
                                    free
                                </span>
                            </p>
                            <button {...defns.cardTrialButton}>Get Started Now</button>
                            <p {...defns.cardParagraph}>
                                <span {...defns.cardBold}>Features:</span>
                            </p>
                            <ul {...defns.cardList}>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Unlimited </span>
                                    Candidate Resume Views
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    Post <span {...defns.cardBold}>3 </span>
                                    ‘Active’ Jobs Simultaneously
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.engageText}>Engage</span> with <strong>60</strong> unique candidates per billing period (<strong>720</strong> for yearly plans)
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>1</span> user seat (account login)
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Basic</span> company Brand Page
                                </li>
                            </ul>
                        </div>
                    </Grid>
                    <Grid {...defns.pricingSection}>
                        <div {...defns.pricingCard}>
                            <p cardParagraph style={{ marginTop: '-25px' }}>
                                <span {...defns.cardPopular}>MOST POPULAR</span>
                            </p>
                            <p {...defns.cardStatus}>Emerging Growth</p>
                            <p {...defns.tire} style={{ marginTop: '5px' }}>
                                Tier 2
                            </p>
                            <p {...defns.cardParagraph}>
                                <span {...defns.cardMoneyMonth} style={{ marginTop: '-9px' }}>
                                    ${numberWithCommas('249')}
                                </span>
                                <span style={{ fontWeight: 'bold' }}> / USD</span> month
                            </p>
                            <p {...defns.cardparagraph}>
                                <span {...defns.cardMoneyYear}>${numberWithCommas('2689')}</span>
                                <span style={{ fontWeight: 'bold' }}> / USD</span> year <span {...defns.cardSave}>Save ${numberWithCommas('359')}</span>
                            </p>
                            <button {...defns.cardTrialButton}>Get Started Now</button>
                            <p {...defns.cardParagraph}>
                                <span {...defns.cardBold}>Features:</span>
                            </p>
                            <ul {...defns.cardList}>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Unlimited</span> Candidate Resume Views
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    Post <span {...defns.cardBold}>7</span> ‘Active’ Jobs Simultaneously
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.engageText}>Engage</span> with <strong>420</strong> unique candidates per billing period (<strong>5,040</strong> for yearly
                                    plans)
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    Internal chat with your team. Never miss a beat!
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>3</span>
                                    {` `}user seats (account logins)
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Full</span> company Brand Page
                                </li>
                            </ul>
                        </div>
                    </Grid>
                    <Grid {...defns.pricingSection}>
                        <div {...defns.pricingCard}>
                            <p {...defns.cardStatus}>Global</p>
                            <p {...defns.tire}>Tier 3</p>
                            <p {...defns.cardParagraph}>
                                <span {...defns.cardMoneyMonth}>${numberWithCommas('499')}</span>
                                <span style={{ fontWeight: 'bold' }}> / USD</span> month
                            </p>

                            <p {...defns.cardparagraph}>
                                <span {...defns.cardMoneyYear}>${numberWithCommas('5389')}</span>
                                <span style={{ fontWeight: 'bold' }}> / USD</span> year <span {...defns.cardSave}>SAVE ${numberWithCommas('599')}</span>
                            </p>
                            <button {...defns.cardTrialButton}>Get Started Now</button>
                            <p {...defns.cardParagraph}>
                                <span {...defns.cardBold}>Features:</span>
                            </p>
                            <ul {...defns.cardList}>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Unlimited </span>
                                    Candidate Resume Views
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    Post <span {...defns.cardBold}>Unlimited </span>Jobs Simultaneously
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Unlimited </span> candidate <span {...defns.engageText}>engagement</span> for <br /> each Job Listing
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>10 </span>user seats (account logins)<span {...defns.cardStar}>*</span>
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    Internal chat with your team. Never miss a beat!
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Full </span>
                                    Company Branding with <br /> <span {...defns.cardBold}> consolidated job listings page</span>
                                </li>
                                <li {...defns.cardParagraph} {...defns.li}>
                                    <span {...defns.cardBold}>Verified ‘Global’ Account Badge – </span> <br />
                                    Exclusive benefit to Tier 3 Plans
                                </li>
                            </ul>
                            <p {...defns.cardLastText}>
                                <span {...defns.cardStar}>*</span>Additional seats can be purchased <br /> at $99 per month / per seat.
                            </p>
                        </div>
                    </Grid>
                </Grid>

                <h1 {...defns.primaryHeading}>
                    Enjoy Exceeding Value With <br /> Any Plan You Choose
                </h1>
                <div>
                    <Grid {...defns.sellingContainer}>
                        <Grid {...defns.sellingSection}>
                            <div {...defns.sellingBox}>
                                <p {...defns.sellingBoxText}>Unlimited resume views for all plans. Where else can you find that?</p>
                            </div>
                            <div {...defns.sellingBox} {...defns.sellingBoxSecondary}>
                                <p {...defns.sellingBoxText}>60 second profile videos revolutionize talent sourcing.</p>
                            </div>
                            <div {...defns.sellingBox}>
                                <p {...defns.sellingBoxText}>Need to reschedule an interview? One click is all you need!</p>
                            </div>
                        </Grid>
                        <Grid {...defns.sellingSection}>
                            <div {...defns.sellingBox} {...defns.sellingBoxSecondary}>
                                <p {...defns.sellingBoxText}>Flexible month to month payment plans.</p>
                            </div>
                            <div {...defns.sellingBox}>
                                <p {...defns.sellingBoxText}>Automated email capabilities - communicate with all parties in a flash.</p>
                            </div>
                            <div {...defns.sellingBox} {...defns.sellingBoxSecondary}>
                                <p {...defns.sellingBoxText}>Questions for a job seeker? Send them a private message with attachments!</p>
                            </div>
                        </Grid>
                        <Grid {...defns.sellingSection}>
                            <div {...defns.sellingBox}>
                                <p {...defns.sellingBoxText}>Your company brand page is an evergreen billboard for new promotions and brand awareness.</p>
                            </div>
                            <div {...defns.sellingBox} {...defns.sellingBoxSecondary}>
                                <p {...defns.sellingBoxText}>Have a large company and need additional seats? We've got you covered!</p>
                            </div>
                            <div {...defns.sellingBox}>
                                <p {...defns.sellingBoxText}>Conduct virtual interviews from the comfort of your home office.</p>
                            </div>
                            <div {...defns.sellingBox} {...defns.sellingBoxSecondary}>
                                <p {...defns.sellingBoxText}>Real-time cloud notifications keep you informed with the pace of business.</p>
                            </div>
                        </Grid>
                        <Grid {...defns.sellingSection}>
                            <div {...defns.sellingBox}>
                                <p {...defns.sellingBoxText}>Meet fresh talent where they are online.</p>
                            </div>
                            <div {...defns.sellingBox} {...defns.sellingBoxSecondary}>
                                <p {...defns.sellingBoxText}>Face to face virtual interviews in a secure session. Why pay for parking?</p>
                            </div>
                        </Grid>
                    </Grid>
                </div>

                <div {...defns.employerContainer} {...defns.lastContainer}>
                    <h2 {...defns.primaryHeading}>Have other questions?</h2>
                    <p {...defns.paragraph}>
                        <AfitdLink {...defns.contactUsLink} onClick={handleContactUsLinkClick}>
                            Contact Us
                        </AfitdLink>
                        here so we can help.
                    </p>
                </div>
            </div>
            <AfitdMessageDialog {...defns.engagementInfoModal} />
            {/* <CreateAccountModal {...defns.createAccount} /> */}

            {/* ================== Login/Register Modal Section ================== */}
            <LoginDialog {...defns.loginDialog} />
            {/* footer added */}
            <Footer />
        </div>
    );
};

export default Employers;
